"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageSelector = void 0;
class MessageSelector {
    constructor(messageList) {
        this.history = [];
        this.messageList = messageList;
    }
    /**
     * main function to be called to get a new exercice
     * @param algo : specify for which algo we want to sample. All the algos dont always have the same sampling strategy
     * @param actID : activity in which we want to sample an exercice
     * @param history : history for this activity in the AI (need to be inside the exerciceManager ?)
     * @param ontology : specify from which ontology to sample from
     * @returns : exerciceId
    */
    next_message(messageType) {
        // let availableMessages = this.messageList[messageType].filter((x: any) => !this.history.includes(x));
        // if (availableMessages.length) {
        //     let messageToSend = availableMessages[Math.floor(Math.random() * availableMessages.length)];
        //     this.history.push(messageToSend);
        //     return messageToSend;
        // }
        // else {
        //     this.history = [];
        //     this.next_message(messageType);
        // }
        return 'randomMessage';
    }
}
exports.MessageSelector = MessageSelector;
